<template>
  <el-tabs class="tabs" v-model="activeName" @tab-click="handleClick">
    <el-tab-pane label="导览章节" name="first">
      <v-chapter :guideId="guideId" @updateChapter="getChapterList"></v-chapter>
    </el-tab-pane>
    <el-tab-pane label="文物讲解" name="second">
      <v-explain :guideId="guideId" :list="list"></v-explain>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import Chapter from './chapter'
import Explain from './explain'
export default {
  components: {
    'v-chapter': Chapter,
    'v-explain': Explain
  },
  data() {
    return {
      activeName: "first",
      guideId: "",
      list: []
    }
  },

  methods: {
    handleClick() {
    },

    getChapterList(list){
      this.list = list
    }
  },

  mounted() {
    this.guideId = this.$route.query.guideId
  }
}
</script>

<style lang="scss" scoped>
.tabs {
  /deep/.el-tabs__nav-wrap {
    &::after{
      display: none;
    }
    .el-tabs__nav-scroll {
      display: flex;
      justify-content: center;
    }
  }
}
</style>